import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function TopBanner() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 30,
    seconds: 0
  });
  const [showButton, setShowButton] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY;
      setIsScrolled(scrollPos > 50);
      setShowButton(scrollPos > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          return {
            hours: 0,
            minutes: 15,
            seconds: 0
          }; // Reset or stop
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const currentDate = new Date().toLocaleDateString('es-AR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
  const scrollToPricing = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + start - 80;
    const duration = 2000;
    const startTime = performance.now();
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + (end - start) * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <div className="bg-gradient-to-r from-[#1a0b2e]/40 via-[#1a0b2e]/40 to-[#1a0b2e]/40 text-white py-2 px-4 sticky top-0 left-0 right-0 z-[70] border-b border-[#ec4899]/20 shadow-[0_4px_20px_rgba(236,72,153,0.2)] backdrop-blur-md" data-id="element-262">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4" data-id="element-263">
        <div className="flex items-center gap-3 overflow-hidden" data-id="element-264">
          <AnimatePresence mode="wait" data-id="element-265">
            {!isScrolled && <motion.div initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -10
          }} className="flex items-center text-[8px] md:text-[10px] gap-[6px] shrink-0" data-id="element-266">
                <span className="bg-[#ec4899] text-white px-2 py-0.5 rounded whitespace-nowrap shadow-[0_0_10px_rgba(236,72,153,0.5)] text-[9px] md:text-[10px] font-black" data-id="element-267">
                  OFERTA LANZAMIENTO:
                </span>
                <span className="font-black whitespace-nowrap text-white/90 text-[8px] md:text-[10px]" data-id="element-268">
                  {currentDate}
                </span>
              </motion.div>}
          </AnimatePresence>

          <div className={`flex items-center gap-1.5 md:gap-2 shrink-0 transition-all duration-300 ${isScrolled ? 'mx-auto' : 'ml-auto md:ml-0'}`} data-id="element-269">
            <div className="flex items-center gap-1 text-white/70" data-id="element-270">
              <Timer className="w-3.5 h-3.5 text-[#00f0ff] animate-pulse" data-id="element-271" />
              <span className="hidden sm:inline text-[9px] font-black tracking-widest whitespace-nowrap" data-id="element-272">
                LA OFERTA TERMINA EN:
              </span>
            </div>
            <div className="flex gap-0.5 font-mono text-sm md:text-base bg-white/5 px-2 py-0.5 rounded border border-white/10" data-id="element-273">
              <span className="font-black text-[#00f0ff] drop-shadow-[0_0_5px_rgba(0,240,255,0.5)]" data-id="element-274">
                {formatNumber(timeLeft.minutes)}
              </span>
              <span className="text-white/30 animate-pulse" data-id="element-275">:</span>
              <span className="font-black text-[#00f0ff] drop-shadow-[0_0_5px_rgba(0,240,255,0.5)]" data-id="element-276">
                {formatNumber(timeLeft.seconds)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}